import styled from 'styled-components';

export const FilesWrapper = styled.div<{ isModalOpen: boolean; zoom: number }>`
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
    display: flex;
    flex-wrap: wrap;
    position: relative;
    margin: 0 auto;
    max-width: ${({ zoom }) => {
        switch (zoom) {
            case 0.6:
                return '1328px';
            case 1:
                return '1323px';
            case 1.4:
                return '1376px';
            case 1.8:
                return '1319px';
            case 2.2:
                return '1316px';
            case 2.6:
                return '987px';
            default:
                return '1323px';
        }
    }};
    opacity: ${({ isModalOpen }) => (isModalOpen ? 0.2 : 1)};

    @media (max-width: 1420px) {
        max-width: ${({ zoom }) => {
            switch (zoom) {
                case 0.6:
                    return '1163px';
                case 1:
                    return '1103px';
                case 1.4:
                    return '1113px';
                case 1.8:
                    return '999px';
                case 2.2:
                    return '881px';
                case 2.6:
                    return '987px';
                default:
                    return '1323px';
            }
        }};
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    overflow: auto;
    margin: 0 auto;
`;
